import { render, staticRenderFns } from "./DistributionForm.vue?vue&type=template&id=eb9f8dee&scoped=true"
import script from "./DistributionForm.vue?vue&type=script&lang=js"
export * from "./DistributionForm.vue?vue&type=script&lang=js"
import style0 from "./DistributionForm.vue?vue&type=style&index=0&id=eb9f8dee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb9f8dee",
  null
  
)

export default component.exports